export enum MarketplaceOperationStatus {
    DOWNLOAD_INITIATED = 'Direct_Download_Initiated',
    DOWNLOAD_STARTED = 'Direct_Download_Start',
    TEMP_UPLOAD_PROGRESS = 'Temp_Upload_Progress',
    DOWNLOAD_COMPLETE = 'Direct_Download_Complete',
    DOWNLOAD_ERROR = 'Direct_Download_Error',
    
    IMPORT_INITIATED = 'Import_Initiated',
    IMPORT_STARTED = 'Import_Start',
    IMPORTING_DOCUMENT = 'Import_Progress',
    UPLOADING_DOCUMENT = 'Uploading_Progress',
    UPDATING_TITLE = 'Updating_Title',
    COMPLETING_IMPORT = 'Import_Complete',
    IMPORT_ERROR = 'Import_Error',

    DOWNLOADING_DOCUMENT = 'Downloading_Progress',
    SPLITTING_DOCUMENT = 'Splitting_Progress'
}
